var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhoneCall = function SvgPhoneCall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.534 2.904a.5.5 0 0 1 .587-.395 3 3 0 0 1 2.37 2.37.5.5 0 0 1-.982.192 2 2 0 0 0-1.58-1.58.5.5 0 0 1-.395-.587"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.528.945A.5.5 0 0 1 7.08.503a5 5 0 0 1 4.417 4.411.5.5 0 0 1-.994.112 4 4 0 0 0-3.533-3.53.5.5 0 0 1-.442-.551M3.169 8.876A10.1 10.1 0 0 1 .597 4.49c-.074-.26-.131-.46-.132-.737 0-.315.102-.71.256-.985.266-.473.836-1.079 1.329-1.328a1.5 1.5 0 0 1 1.354 0c.418.211.897.7 1.152 1.092a1.5 1.5 0 0 1 0 1.635c-.087.133-.21.256-.354.4-.044.044-.094.076-.06.144a6.8 6.8 0 0 0 1.325 1.868 6.8 6.8 0 0 0 1.868 1.326c.07.034.098-.015.145-.061.143-.143.266-.267.4-.354a1.5 1.5 0 0 1 1.634 0c.392.255.881.734 1.092 1.152a1.5 1.5 0 0 1 0 1.354c-.247.489-.848 1.06-1.328 1.329-.275.154-.67.257-.985.256-.276 0-.477-.058-.737-.132a10.1 10.1 0 0 1-4.387-2.572"
  }))));
};
export default SvgPhoneCall;